module.exports = __webpack_public_path__ + "media/0.4d022a4c.mp4";